export enum ServerActionName {
  // Account
  CreateUserAccounts = "createUserAccounts",
  DeleteUser = "deleteUser",
  GetUserById = "getUserById",
  ListUserAccount = "listUserAccount",
  SendUserVerification = "sendUserVerification",
  UpdateUserAccount = "updateUserAccount",
  GetSupplierConfig = "getSupplierConfig",

  // Attribute
  AddLibraryAttribute = "addLibraryAttribute",
  BulkUpsertCategoryToAttributes = "bulkUpsertCategoryToAttributes",
  CreateCustomAttribute = "createCustomAttribute",
  DeleteAttribute = "deleteAttribute",
  GetAttributeInUseCount = "getAttributeInUseCount",
  GetLibraryAttributes = "getLibraryAttributes",
  GetSupplierAttributeList = "getSupplierAttributeList",
  UpdateAttribute = "updateAttribute",
  GetAttributesForEnrichment = "getAttributesForEnrichment",

  // Authentication
  Login = "login",
  ResendVerificationLink = "resendVerificationLink",
  SendResetPasswordEmail = "sendResetPasswordEmail",
  SetPassword = "setPassword",
  UpdateEmailAddress = "updateEmailAddress",
  UpdatePassword = "updatePassword",
  VerifyEmailAddress = "verifyEmailAddress",

  // Channel
  getEntitledChannelList = "getEntitledChannelList",
  GetChannelCategories = "getChannelCategories",
  GetChannelConfigurationList = "getChannelConfigurationList",
  GetChannelList = "getChannelList",
  UpdateChannelSettings = "updateChannelSettings",
  UpdateProductChannels = "updateProductChannels",

  // Common
  GetCurrencyList = "getCurrencyList",
  GetGoogleCategoriesList = "getGoogleCategoriesList",
  GetLocaleCountries = "getLocaleCountries",

  // Dashboard
  GetDashboardAverage = "getDashboardAverage",
  GetDashboardTotal = "getDashboardTotal",

  // Category Tree
  GetTaxonomyTree = "getTaxonomyTree",
  GetTaxonomyTreeNode = "getTaxonomyTreeNode",
  UpdateTaxonomyTreeNode = "updateTaxonomyTreeNode",
  GetTaxonomyTreeMaxDepth = "getTaxonomyTreeMaxDepth",

  // DAM
  CreateDamTask = "createDamTask",
  GetDamList = "getDamList",
  GetDamTaskList = "getDamTaskList",
  GetFileDetail = "getFileDetail",

  // Enrichment
  ApproveEnrichImages = "approveEnrichImages",
  CancelEnrichImageTasks = "cancelEnrichImageTasks",
  GetEnrichImagesReviewProducts = "getEnrichImagesReviewProducts",
  GetEnrichmentStatus = "getEnrichmentStatus",
  GetEnrichmentTaskList = "getEnrichmentTaskList",
  StartEnrichment = "startEnrichment",

  // Chat
  CreateEnrichmentReview = "createEnrichmentReview",
  CreateGenericReview = "createGenericReview",
  GetEnrichmentReviewDetail = "getEnrichmentReviewDetail",
  CreateAiProductSearch = "createAiProductSearch",
  GetAiProductSearchDetail = "getAiProductSearchDetail",
  CreateImageOcr = "createImageOcr",
  GetImageOcrDetail = "getImageOcrDetail",

  // Export
  CreateExportTemplate = "createExportTemplate",
  CreateExportTask = "createExportTask",
  DeleteExportTemplate = "deleteExportTemplate",
  DuplicateExportTemplate = "duplicateExportTemplate",
  GetAvailableFixedExportTemplateList = "getAvailableFixedExportTemplateList",
  GetAvailableCustomExportTemplateList = "getAvailableCustomExportTemplateList",
  GetCustomTemplate = "getCustomTemplate",
  GetCustomTemplateList = "getCustomTemplateList",
  GetExportTask = "getExportTask",
  GetExportTaskList = "getExportTaskList",
  UpdateCustomTemplate = "updateCustomTemplate",
  CreateExportImageTask = "createExportImageTask",

  // Feature
  GetFeatureToggles = "getFeatureToggles",
  SetFeatureToggle = "setFeatureToggle",

  // File
  DeleteFiles = "deleteFiles",
  GetFilesList = "getFilesList",
  RetrieveDownloadUrl = "retrieveDownloadUrl",
  UploadFileFromUrl = "uploadFileFromUrl",
  ReferenceFileToProduct = "referenceFileToProduct",

  // Localization
  CreateLocalizationTask = "createLocalizationTask",
  CreateBatchLocalizationTask = "createBatchLocalizationTask",
  GetLocalizationTaskList = "getLocalizationTaskList",
  GetMasterProductLocalizationStatus = "getMasterProductLocalizationStatus",

  // Product
  AddFileToGallery = "addFileToGallery",
  CreateProduct = "createProduct",
  CreateVariantProduct = "createVariantProduct",
  DeleteProduct = "deleteProduct",
  DuplicateProduct = "duplicateProduct",
  GetVariantDisplayAttributes = "getVariantDisplayAttributes",
  GetBasicProduct = "getBasicProduct",
  GetCreateProductTemplate = "getCreateProductTemplate",
  GetProduct = "getProduct",
  GetProductSkuIds = "GetProductSkuIds",
  GetProductList = "getProductList",
  GetProductListLegacy = "getProductListLegacy",
  GetProductListCount = "getProductListCount",
  GetVariantProducts = "getVariantProducts",
  InitializeExportAuditLog = "initializeExportAuditLog",
  RemoveFileFromGalleryAction = "removeFileFromGalleryAction",
  UpdateAttributeBlame = "updateAttributeBlame",
  UpdateProduct = "updateProduct",
  DeleteFileAndProductReferences = "deleteFileAndProductReferences",
  GetEnrichedAttributesSources = "getEnrichedAttributeSources",
  GetEnrichedAttributesSourcesCount = "getEnrichedAttributeSourcesCount",
  GetProductEnrichmentStatus = "getProductEnrichmentStatus",
  RelinkVariants = "relinkVariants",
  GetSupplierProductCount = "getSupplierProductCount",
  GetSkuChildrenCount = "getSkuChildrenCount",
  GetProductLocaleCount = "getProductLocaleCount",

  // Feedback
  CreateEnrichmentFeedback = "createEnrichmentFeedback",
  UpdateEnrichmentFeedback = "updateEnrichmentFeedback",
  GetLatestEnrichmentFeedback = "getLatestEnrichmentFeedback",
  RecalculateProductFillRate = "recalculateProductFillRate",

  // Smart Upload
  ArchiveTask = "archiveTask",
  FieldMapping = "fieldMapping",
  GenerateS3Url = "generateS3Url",
  GetActiveTasks = "getActiveTasks",
  ImportTasks = "importTasks",
  ListAttributes = "listAttributes",
  SearchImportTaskStatus = "searchImportTaskStatus",
}
